module.exports = __webpack_public_path__ + "static/media/near.26d90875.JPG";